
import Vue from 'vue'
import BaseLayout from '@/components/BaseLayout.vue'

export default Vue.extend({
  name: 'TheNoSidebarTemplate',

  components: {
    BaseLayout,
  },
})
